// i18 dictionary
export enum TicketTranslations {
  NEW = 'tickets:new',
  OPENED = 'tickets:opened',
  CLOSED = 'tickets:closed',
  SOLVED = 'tickets:solved',
  TICKET_STATUS_ERROR = 'tickets:ticket-status-error',
}
